var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2344 24.2031C43.4531 15.9375 34.5469 10.8125 25 10.8125C15.4531 10.8125 6.54687 15.9375 1.76562 24.2031C1.5 24.6875 1.5 25.2812 1.76562 25.7656C6.54687 34.0469 15.4531 39.1875 25 39.1875C34.5469 39.1875 43.4531 34.0469 48.2344 25.7656C48.5 25.2812 48.5 24.6875 48.2344 24.2031ZM25 34.7656C19.6094 34.7656 15.2344 30.3906 15.2344 25C15.2344 19.6094 19.6094 15.2344 25 15.2344C30.3906 15.2344 34.7656 19.6094 34.7656 25C34.7656 30.3906 30.3906 34.7656 25 34.7656Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31.6406C28.6675 31.6406 31.6406 28.6675 31.6406 25C31.6406 21.3325 28.6675 18.3594 25 18.3594C21.3325 18.3594 18.3594 21.3325 18.3594 25C18.3594 28.6675 21.3325 31.6406 25 31.6406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.ddd5a80580707701d91db95d55ad2732.svg";
export { ForwardRef as ReactComponent };